import { useEffect } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { useGradeFlow } from '@/states/grade-flow';

export const useInitHypertensiveForm = () => {
  const { setInitialHypertensiveForm } = useGradeFlow(
    useShallow((s) => ({
      setInitialHypertensiveForm: s.setInitialHypertensiveForm,
    }))
  );

  // Update Zustand state with default empty hypertensive form
  useEffect(() => {
    setInitialHypertensiveForm();
  }, []);
};
